import React, { useState } from "react";
import Footer from "../components/footer";
import dw from "web-digital-watermarking";
import { GenericModal } from "../ui/Modals";

const Createpage = () => {
  // variables to capture image
  const [fileUpload, setFileUpload] = useState([]);
  const [uploadedPic, setUploadedPic] = useState();

  // Used pic and img to emphasize difference in encoded / decoded variable names

  const [decodedImgObj, setDecodedImgObj] = useState();
  const [isLoading, setIsloading] = useState(false);

  function uploadFileChangeHandler(event) {
    var files = event.target.files;
    var filesArr = Array.prototype.slice.call(files);
    document.getElementById("file_name").style.display = "none";

    setFileUpload((prevState) => [prevState, ...filesArr]);

    setUploadedPic(URL.createObjectURL(files[0]));
  }

  const decodeFunc = async () => {
    try {
      console.log("triggered decode function");
      setIsloading(true);
      const deCodeImageUrl = await dw.getTextFormImageUrl(uploadedPic);
      setDecodedImgObj(deCodeImageUrl);
      setIsloading(false);
    } catch (e) {
      console.log(e);
      setIsloading(false);
    }
  };

  return (
    <div>
      <section className="jumbotron breadcumb no-bg">
        <div className="mainbreadcumb">
          <div className="container">
            <div className="row m-10-hor">
              <div className="col-12">
                <h1 className="text-center">Verify Copyright</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container">
        <div className="row">
          <div className="col-lg-7 offset-lg-1 mb-5">
            <form id="form-create-item" className="form-border" action="#">
              <div className="field-set">
                <h5>Upload image file</h5>

                <div className="d-create-file">
                  <p id="file_name">PNG, JPG, GIF, WEBP or MP4. Max 200mb.</p>
                  {fileUpload.map((x) => (
                    <p key={x}>PNG, JPG, GIF, WEBP or MP4. Max 200mb.{x.name}</p>
                  ))}
                  <div className="browse">
                    <input type="button" id="get_file" className="btn-main" value="Browse" />
                    <input id="upload_file" type="file" multiple onChange={uploadFileChangeHandler} />
                  </div>
                </div>
                <div className="spacer-single"></div>

                <button type="button" id="submit" className="btn-main" onClick={decodeFunc}>
                  Decode
                </button>
                {isLoading === true && (
                  <div>
                    <div className="spacer-10"></div>
                    <GenericModal title={"LOADING..."}>LOADING......</GenericModal>
                  </div>
                )}
                {decodedImgObj !== undefined && isLoading === false && (
                  <div>
                    <div className="spacer-20"></div>
                    <h5>Decoded Image</h5>
                    <div className="nft_pic">
                      <img src={decodedImgObj} alt="" />
                    </div>
                  </div>
                )}

                <div className="spacer-single"></div>
              </div>
            </form>
          </div>

          <div className="col-lg-3 col-sm-6 col-xs-12">
            <h5>Uploaded image</h5>
            <div className="nft__item m-0">
              <div className="nft__item_wrap">
                <span>
                  <img src={uploadedPic} id="get_file_2" className="lazy nft__item_preview" alt="" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Createpage;
